import React from 'react';
import { Button } from 'reactstrap';
import { useTheme } from '../../contexts/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = ({ className = '', fullWidth = false }) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const nextModeLabel = isDarkMode ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Button
      className={`theme-toggle-button${fullWidth ? ' theme-toggle-button--full-width' : ''}${className ? ` ${className}` : ''}`}
      color="link"
      onClick={toggleTheme}
      type="button"
      aria-label={nextModeLabel}
      title={nextModeLabel}
    >
      <span className="theme-toggle-button__track" aria-hidden="true">
        <span className={`theme-toggle-button__thumb${isDarkMode ? ' is-dark' : ' is-light'}`}>
          <i className={`tim-icons ${isDarkMode ? 'icon-light-3' : 'icon-refresh-02'} theme-toggle-icon`} />
        </span>
      </span>
    </Button>
  );
};

export default ThemeToggle;